<template>
  <div class="flex items-center h-11 px-3 gap-3">
    <button class="text-gray-600 h-7" @click="isMobileMainNavOpen = true">
      <u-icon name="i-ri-menu-line" class="h-7 w-7" />
    </button>

    <nuxt-link class="block flex-1" to="/" external>
      <core-logo class="h-6" />
    </nuxt-link>

    <client-only> <!-- todo: review if adding client-only is ok here - fixes a hydraditon warning-->
      <div v-if="currentUser" @click="isMobileProfileNavOpen = true" role="button" class="inline-flex">
        <user-avatar
          :user="currentUser"
          size="sm"
          :chip-color="newCount ? 'red' : null"
          chip-position="top-right"
        />
      </div>
    </client-only>

    <u-slideover v-model="isMobileMainNavOpen" side="left" :ui="{width: 'max-w-[240px]'}" class="overflow-y-auto">
      <div class="bg-white">
        <layout-navigation-main @item-click="isMobileMainNavOpen = false" />
      </div>
    </u-slideover>

    <u-slideover v-model="isMobileProfileNavOpen" :ui="{width: 'max-w-[320px]'}">
      <div class="bg-white flex flex-col h-full">
        <div class="flex-1 overflow-y-auto pb-28">
          <layout-profile-navigation :close-function="closeProfileNav" />
        </div>
        <div class="sticky bottom-0 bg-white px-4 py-3 flex items-center gap-3">
          <div v-if="isImpersonating" class="w-1/2 flex flex-col items-center gap-2 bg-gray-100/60 rounded px-2 py-2 text-center">
            <p class="uppercase text-2xs font-bold text-gray-600">Acting on behalf of</p>
            <user-avatar
              :user="currentUser"
              :chip-color="newCount ? 'red' : null"
              chip-position="top-right"
              size="md"
              class="ring-2 ring-red-400 ring-offset-2"
            />
            <nuxt-link to="/impersonate" class="uppercase text-heroblue font-semibold underline-on-hover text-2xs" @click="closeProfileNav">
              Stop Managing
            </nuxt-link>
          </div>

          <div :class="isImpersonating ? 'w-1/2 flex justify-end' : 'w-full flex justify-center'">
            <div class="bg-gray-100/60 rounded px-2 py-2 w-full flex">
              <layout-storage-summary class="w-full" width-class="w-full" meter-width-class="w-full" />
            </div>
          </div>
        </div>
      </div>
    </u-slideover>

  </div>
</template>

<script setup>
  const sessionStore = useSessionStore();
  const {currentUser, isImpersonating} = storeToRefs(sessionStore);
  const isMobileMainNavOpen = ref(false);
  const isMobileProfileNavOpen = ref(false);

  const notificationsStore = useNotificationStore();
  const {newCount} = storeToRefs(notificationsStore);

  function closeProfileNav() {
    isMobileProfileNavOpen.value = false;
  }
</script>
